import { render, staticRenderFns } from "./MonthlyThermalCpuBurnInFailRateSummary.vue?vue&type=template&id=76f4c680"
import script from "./MonthlyThermalCpuBurnInFailRateSummary.vue?vue&type=script&lang=js"
export * from "./MonthlyThermalCpuBurnInFailRateSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports